import {Translate} from "./Translate";
import {getStore} from "trim-redux";

export const TablePage = 10;
export const TableCount = [10,20,50,100,200];
export const TableCountForCat = [3,5,10];

export const RWN = () => {
    let features = getStore('features');
    let rwn = {
        admin: Translate.admin,
        support: Translate.supportUser,
        user: Translate.user,
    };
    if(!!features.marketplace){
        rwn['supplier'] = Translate.supplier
    }
    if(!!features.agent){
        rwn['agent'] = Translate.agent
    }
    return rwn;
};

export const rolesWithName = () => {
    let features = getStore('features');
    let rwn = [
        {
            value: "admin",
            type: "admin",
            name : Translate.admin
        },
        {
            value: "support",
            type: "admin",
            name : Translate.supportUser
        },
        {
            value: "user",
            type: "normal",
            name : Translate.user
        },
    ];
    if(!!features.marketplace){
        rwn.push(
            {
                value: "supplier",
                type: "normal",
                name : Translate.supplier
            }
        )

    }
    if(!!features.agent){
        rwn.push(
            {
                value: "agent",
                type: "normal",
                name : Translate.agent
            }
        )

    }
    return rwn;
};
export const typesWithName = [
    {
        value: "admin",
        name : Translate.adminType
    },
    {
        value: "normal",
        name : Translate.normalType
    },
];
